
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/fast-delivery",
      function () {
        return require("private-next-pages/fast-delivery/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/fast-delivery"])
      });
    }
  